module.exports = __webpack_public_path__ + "img/Logo-ICFA-header.6168a2f.png";